
import { FormType } from '../../../../form-types';
import { LichenSclerosusFieldAnswers } from '../questions';

export const lichenSclerosus: FormType<LichenSclerosusFieldAnswers> = {
  name: 'Lichen Sclerosus Consultation',
  questions: [
    {
      key: 'lichenSclerosus_sex',
      next: {
        condition: { 'lichenSclerosus_sex.male': true },
        key: 'lichenSclerosus_previouslyDiagnosed',
        els: 'lichenSclerosus_pregnant'
      }
    },
    'lichenSclerosus_pregnant',
    {
      key: 'lichenSclerosus_previouslyDiagnosed',
      next: {
        condition: { 'lichenSclerosus_previouslyDiagnosed.yes': true },
        key: 'lichenSclerosus_diagnosingClinician',
        els: 'lichenSclerosus_currentlyExperiencingSymptoms'
      }
    },
    {
      key: 'lichenSclerosus_diagnosingClinician',
      next: {
        condition: { 'lichenSclerosus_diagnosingClinician.other': true },
        key: 'lichenSclerosus_diagnosingClinicianOther',
        els: 'lichenSclerosus_yearDiagnosed'
      }
    },
    {
      key: 'lichenSclerosus_diagnosingClinicianOther',
      next: {
        key: 'lichenSclerosus_yearDiagnosed'
      }
    },
    'lichenSclerosus_yearDiagnosed',
    'lichenSclerosus_howDiagnosisMade',
    'lichenSclerosus_currentlyExperiencingSymptoms',
    {
      key: 'lichenSclerosus_symptoms',
      next: {
        condition: { 'lichenSclerosus_symptoms.noSymptoms': true },
        key: 'lichenSclerosus_ineligible',
        els: 'lichenSclerosus_physicalExamFindings'
      }
    },
    {
      key: 'lichenSclerosus_physicalExamFindings',
      next: {
        condition: { 'lichenSclerosus_physicalExamFindings.other': true },
        key: 'lichenSclerosus_physicalExamFindingsOther',
        els: 'lichenSclerosus_symptomsDuration'
      }
    },
    'lichenSclerosus_physicalExamFindingsOther',
    'lichenSclerosus_symptomsDuration',
    'lichenSclerosus_symptomsDescription',
    {
      key: 'lichenSclerosus_usedHighPotencySteroid',
      next: {
        condition: { 'lichenSclerosus_usedHighPotencySteroid.yes': true },
        key: 'lichenSclerosus_steroidMedicationUsed',
        els: 'lichenSclerosus_steroidSideEffects'
      }
    },
    'lichenSclerosus_steroidMedicationUsed',
    'lichenSclerosus_steroidFrequency',
    'lichenSclerosus_symptomsResponseToTreatment',
    {
      key: 'lichenSclerosus_steroidSideEffects',
      next: {
        condition: { 'lichenSclerosus_steroidSideEffects.yes': true },
        key: 'lichenSclerosus_steroidSideEffectsDetails',
        els: 'lichenSclerosus_currentlyUsingTopical'
      }
    },
    'lichenSclerosus_steroidSideEffectsDetails',
    {
      key: 'lichenSclerosus_currentlyUsingTopical',
      next: {
        condition: { 'lichenSclerosus_currentlyUsingTopical.yes': true },
        key: 'lichenSclerosus_currentTopicalMedication',
        els: 'lichenSclerosus_redFlagConditions'
      }
    },
    'lichenSclerosus_currentTopicalMedication',
    {
      key: 'lichenSclerosus_redFlagConditions',
      next: {
        condition: { 'lichenSclerosus_redFlagConditions.none': true },
        key: 'lichenSclerosus_otherInformation',
        els: 'lichenSclerosus_ineligible'
      }
    },
    'lichenSclerosus_otherInformation',
    {
      key: 'lichenSclerosus_truthfulnessConsent',
      next: {
        condition: { 'lichenSclerosus_truthfulnessConsent.consent': true },
        key: 'lichenSclerosus_consent',
        els: 'lichenSclerosus_nonConsent'
      }
    },
    {
      key: 'lichenSclerosus_consent',
      next: {
        condition: { 'lichenSclerosus_consent.consent': true },
        key: 'lichenSclerosus_complete',
        els: 'lichenSclerosus_nonConsent'
      }
    },
    'lichenSclerosus_nonConsent',
    'lichenSclerosus_ineligible',
    'lichenSclerosus_complete'
  ]
};
